import React, { ChangeEvent, useEffect, useState } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  TextField,
  CircularProgress,
  Dialog,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { checkResetLinkTC, isLinkValidType, updatePasswordByLinkTC } from './auth-reducer';
import { useLocation, useNavigate } from 'react-router-dom';
import { AppRootState } from '../../app/store';
import { AlarmLinkNotValid } from './AlarmLinkNotValid';


export const ResetPassword = React.memo(() => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const search = useLocation().search
  const data = new URLSearchParams(search).get('data')

  const isLinkValid = useSelector<AppRootState, isLinkValidType>(state => state.auth.isResetLinkValid)
  console.log('isLinkValide', isLinkValid)
  async function checkLink () {
    if(data){
     const status =  dispatch(checkResetLinkTC({data}))
     console.log('Staatus', status)
    }
  }

  useEffect(() => {
    console.log('Data d useEffecte', data)
    checkLink()
    
  }, [])

  const [isInProgress, SetProgress] = useState(false)
  const [err, setError] = useState(false)
  const [values, setValues] = useState({
    password: '',
    confirm: ''
  });

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });
  }

  async function updatePassword() {
    if (values.password !== values.confirm) {
      setError(true)
    } else {
      SetProgress(true)
      setError(false)
      await dispatch(updatePasswordByLinkTC({newPassword: values.confirm }))
      setValues({ password: '', confirm: '' })
      SetProgress(false)
      navigate('/login')
    }
  }

  return (
   < >
      {isLinkValid === true ?
       <>
      <Dialog open={isInProgress} >
        <CircularProgress color="info" thickness={4} size={60} style={{ position: 'fixed', marginTop: '0px', left: '50%', width: 100, height: 100 }} />
      </Dialog>
      <Card style={{marginTop: '100px'}}>
            <CardHeader
              title="Reset password"
            />
            <Divider />
            <CardContent>
              <TextField
                fullWidth
                label="new password"
                margin="normal"
                name="password"
                onChange={handleChange}
                type="password"
                value={values.password}
                variant="outlined"
              />
              <TextField
                fullWidth
                error={err}
                label="comfirm password"
                margin="normal"
                name="confirm"
                onChange={handleChange}
                type="password"
                value={values.confirm}
                variant="outlined"
              />
            </CardContent>
            <Divider />
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                p: 2
              }}
            >

              <Button
                color="info"
                variant="contained"
                onClick={updatePassword}
                disabled={values.password === '' && values.confirm == ''}
              >
                Save
              </Button>
            </Box>
      </Card>
      </>
      :  
      isLinkValid === '' ? <CircularProgress color="info" thickness={2} size={20} style={{ position: 'fixed',marginTop: '380px', left:'50%',  width: 80, height: 80 }}/>
      :
      <AlarmLinkNotValid   />
      }
    </> 
  );
});
